"use strict";
import React from "react";
import $ from "jquery";
import TypeAhead from "./ui/type_ahead";
function search(name) {
  return Promise.resolve($.get("/api/customers", { filterTerms: name })).then(
    function(data) {
      const results = data.customers;
      return results;
    }
  );
}
function customerDisplay(customer) {
  var html = customer.name;
  if (customer.account_number) {
    html += " - # ";
    html += customer.account_number;
  }
  return html;
}
function CustomerTypeAhead(props) {
  return /* @__PURE__ */ React.createElement(
    TypeAhead,
    {
      "data-component": "CustomerTypeAhead",
      remoteSearch: search,
      display: customerDisplay,
      readOnly: props.readOnly,
      placeHolder: "Customer Name",
      className: "customer-setter__typeahead",
      isDroppable: true,
      selectedItem: props.customer,
      onSelectItem: props.onSelectCustomer,
      onClearSelectedItem: props.onClearCustomer
    }
  );
}
export default CustomerTypeAhead;
